var Schema = require("lib/shared/Schema");
var APIClient = require("lib/web/APIClient");
var ActionUtility = require("lib/shared/ActionUtility");
var Queries = require("lib/shared/Queries");
var CurrentUser = require("lib/account/CurrentUser");

////////////////////////////////////////
// Avatar //////////////////////////////
////////////////////////////////////////

export const updateAvatar = ({ id, update, embeds, query }) => {
	const params = _.extend({}, query, { avatar: update });

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecord(
			APIClient.patchAvatar,
			id,
			{ avatar: Schema.AVATAR },
			{ params, embeds },
			{ reducer: "avatar", loading: "update" }
		))
	}
}

////////////////////////////////////////
// Furniture ///////////////////////////
////////////////////////////////////////

export const fetchFurnitures = (attributes = {}) => {
	const { filters, conditions, embeds, cache } = attributes;
	const params = Queries.toQuery({ ...filters, furniture_only: true }, conditions);

	return dispatch =>
		dispatch(
			ActionUtility.fetchRecords(
				APIClient.getPerks,
				{ furnitures: [Schema.FURNITURE] },
				{ params, embeds },
				{ reducer: "furnitures", loading: "index", cache },
			),
		);
};

export const updateFurnitures = ({ ids, newProperties }) => dispatch =>
	dispatch({
		type: ActionUtility.UPDATE_RECORDS,
		furnitures: ids,
		update: newProperties,
	});

export const postFurnitures = ({ furniture, newProperties, embeds, query, callback }) => {
	var params = _.extend({}, query, {
		furniture: { ...furniture, ...newProperties },
	});

	return dispatch => {
		dispatch({
			type: ActionUtility.UPDATE_RECORDS,
			furnitures: [furniture.id],
			update: newProperties,
		});
		return dispatch(
			ActionUtility.fetchRecords(
				q =>
					APIClient.postPerks(q).then(response => {
						callback(response);
						return response;
					}),
				{ furniture: Schema.FURNITURE },
				{ params, embeds },
				{ reducer: "furniture", loading: "update" },
			),
		);
	};
};

////////////////////////////////////////
// Patches /////////////////////////////
////////////////////////////////////////

export const fetchPatches = (attributes = {}) => {
	const { filters, conditions, embeds, cache } = attributes;
	const params = Queries.toQuery(filters, conditions);

	return dispatch =>
		dispatch(
			ActionUtility.fetchRecords(
				APIClient.getPatches,
				{ patches: [Schema.PATCH] },
				{ params, embeds },
				{ reducer: "patches", loading: "index", cache },
			),
		);
};

export const updatePatches = ({ ids, newProperties }) => dispatch =>
	dispatch({
		type: ActionUtility.UPDATE_RECORDS,
		patches: ids,
		update: newProperties,
	});

export const postPatches = ({ patch, newProperties, embeds, query, callback }) => {
	var params = _.extend({}, query, { patch: { ...patch, ...newProperties } });

	return dispatch => {
		dispatch({
			type: ActionUtility.UPDATE_RECORDS,
			patches: [patch.id],
			update: newProperties,
		});
		return dispatch(
			ActionUtility.fetchRecords(
				q =>
					APIClient.postPatches(q).then(response => {
						callback(response);
						return response;
					}),
				{ patch: Schema.PATCH },
				{ params, embeds },
				{ reducer: "patches", loading: "update" },
			),
		);
	};
};

////////////////////////////////////////
// Perks ///////////////////////////////
////////////////////////////////////////

export const fetchPerks = (attributes = {}) => {
	const { filters, conditions, embeds, cache } = attributes;
	const params = Queries.toQuery(filters, conditions);

	return dispatch =>
		dispatch(
			ActionUtility.fetchRecords(
				APIClient.getPerks,
				{ perks: [Schema.PERK] },
				{ params, embeds },
				{ reducer: "perks", loading: "index", cache },
			),
		);
};

export const updatePerks = ({ ids, newProperties }) => dispatch =>
	dispatch({
		type: ActionUtility.UPDATE_RECORDS,
		perks: ids,
		update: newProperties,
	});

export const postPerks = ({ perk, newProperties, embeds, query, callback }) => {
	//new_properties allows the removal of perks without setting name : ""
	var params = _.extend({}, query, { perk: { ...perk }, new_properties: {...newProperties} });

	return dispatch => {
		dispatch({
			type: ActionUtility.UPDATE_RECORDS,
			perks: [perk.id],
			update: newProperties,
		});
		return dispatch(
			ActionUtility.fetchRecords(
				q =>
					APIClient.postPerks(q).then(response => {
						callback(response);
						return response;
					}),
				{ perk: Schema.PERK },
				{ params, embeds },
				{ reducer: "perks", loading: "update" },
			),
		);
	};
};

////////////////////////////////////////
// Photographs /////////////////////////
////////////////////////////////////////

export function createPhotograph({ photograph, embeds }) {
	var params = { photograph };

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.postPhotographs,
			{ photograph: Schema.PHOTOGRAPH },
			{ embeds, params },
			{ reducer: "photographs", loading: "create" }
		))
	}
}

export const fetchPhotographs = ({ filters, conditions, embeds, query, page, cache }) => {
  const params = { ...Queries.toQuery(filters, conditions), ...query }

  return dispatch =>
    dispatch(
      ActionUtility.fetchRecords(
        APIClient.getPhotographs,
        { photographs: [Schema.PHOTOGRAPH] },
        { params, embeds, page },
        { reducer: "photographs", loading: "index", cache }
      )
    );
};



// WEBPACK FOOTER //
// ./modules/lib/actions/OwlShopActions.js